var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_c('strong',[_vm._v(_vm._s(_vm.$t("booking.board-basis"))+" : ")]),_vm._v(" "+_vm._s(" " + _vm.basisCode + " " + _vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }